import {Box, Button, IconButton, Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {useAuthorizationsStore} from 'presentation/pages/private/authorizations/store/authorizationsStore';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {formatText} from 'presentation/utils';
import {openGoogleMaps} from 'presentation/pages/private/authorizations/utils/openGoogleMaps';
import {formatProviderAddress} from 'presentation/pages/private/authorizations/utils/formatProviderAddress';
import {ProviderCardProps} from '../types';

const {seeMap} = translations['pt-br'].commons;

export const ProviderCard = ({
	provider,
	onDeleteProvider,
	removeButtonDataTagId,
}: ProviderCardProps) => {
	const theme = useTheme();

	const {removeProviderById} = useAuthorizationsStore();

	const handleDeleteProvider = () => {
		removeProviderById(provider?.idUnico);
		onDeleteProvider?.();
	};

	return (
		<Stack p={2} border={`1px solid ${theme.palette.divider}`} borderRadius={1}>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<Typography variant="body1" color="text.primary" fontWeight="600">
					{formatText(provider?.nmPrestador)}
				</Typography>
				<IconButton
					sx={{p: 0}}
					size="medium"
					onClick={handleDeleteProvider}
					data-tag-id={removeButtonDataTagId}>
					<Icon name="close-default" color={theme.colors.brand.primary.blue} />
				</IconButton>
			</Box>
			<Box sx={{marginTop: 0}}>
				<Typography variant="body2" color="text.primary">
					{formatProviderAddress(provider)}
				</Typography>
				<Button
					variant="text"
					color="primary"
					sx={{cursor: 'pointer', padding: 0, fontWeight: 400, lineHeight: '150%'}}
					onClick={() => openGoogleMaps(provider)}>
					{seeMap}
				</Button>
			</Box>
		</Stack>
	);
};
